<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="alarmDevice()"
  [showDiscontinuedWarning]="(isDiscontinued$ | async) || false"
  imageUrl="./assets/icons-blue/alarmmittel_blau.svg"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    <app-floorplan-item-attachments-button
      [productItems]="productItems"
      [customProducts]="alarmDevice().products"
    ></app-floorplan-item-attachments-button>

    <app-floorplan-item-group [floorplanItem]="alarmDevice()"></app-floorplan-item-group>
  </div>
  <div data-extended>
    <app-floorplan-alarm-device-detail-form [alarmDevice]="alarmDevice()"> </app-floorplan-alarm-device-detail-form>
  </div>
</app-floorplan-item-details>
